
























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import pagelist from "@/components/pagelistcomponent";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import showauditlogs from "./showauditlogs.vue";
@Component({ components: { showauditlogs } })
export default class auditlog extends pagelist {
  get auditproxy() {
    return new proxy.AuditLogServiceProxy();
  }
  input: proxy.GetAuditLogsInput = new proxy.GetAuditLogsInput();
  rangdate = [
    new Date(new Date(new Date().toLocaleDateString()).getTime()),
    new Date(),
  ];
  createOrEditShow = false;
  sub_model: proxy.AuditLogListDto = new proxy.AuditLogListDto();
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: "状态",
      slot: "exception",
    },
    {
      title: "执行时间",
      slot: "executionTime",
    },
    {
      title: "用户名",
      key: "userName",
    },
    {
      title: "服务",
      key: "serviceName",
    },
    {
      title: "操作",
      key: "methodName",
    },
    {
      title: "持续时间",
      slot: "executionDuration",
    },
    {
      title: "Ip地址",
      key: "clientIpAddress",
    },
    {
      title: "浏览器",
      key: "browserInfo",
    },
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.startDate = this.rangdate[0];
    this.input.endDate = this.rangdate[1];

    this.auditproxy.queryAuditLogs(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  showdetail(row) {
    this.sub_model = proxy.AuditLogListDto.fromJS(row);
    this.createOrEditShow = true;
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
  audit(e) {
    if (e == 0) {
      this.auditproxy.setAuditIsEnable(true).then(() => {
        this.$Notice.success({ title: "审计日志已启用" });
      });
    }
    if (e == 1) {
      this.auditproxy.setAuditIsEnable(false).then(() => {
        this.$Notice.success({ title: "审计日志已禁用" });
      });
    }
  }
}
